import React, { useState, useEffect, useRef } from "react";
import { Link, useParams } from "react-router-dom";
import Quill from 'quill';
import 'quill/dist/quill.snow.css';
import * as api from "../../../services/apiService";
import Toast from "react-bootstrap/Toast";
import "./ProblemEditPage.scss";

function ProblemEditPage() {
  const { ProblemId } = useParams();

  const [text, setText] = useState("");
  const [title, setTitle] = useState("");
  const [organization, setOrganization] = useState("");
  const [user, setUser] = useState("");
  const [published, setPublished] = useState(false);
  const [status, setStatus] = useState(false);
  const [loading, setLoading] = useState(true);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  const editorRef = useRef(null);
  const quillInstance = useRef(null);

  useEffect(() => {
    quillInstance.current = new Quill(editorRef.current, {
      modules: {
        toolbar: true,
      },
      placeholder: 'Introduceți textul aici...',
      theme: 'snow',
    });

    quillInstance.current.on('text-change', () => {
      setText(quillInstance.current.root.innerHTML);
    });

    return () => {
      quillInstance.current = null;
    };
  }, []);

  useEffect(() => {
    if (quillInstance.current && text !== quillInstance.current.root.innerHTML) {
      quillInstance.current.root.innerHTML = text || '';
    }
  }, [text]);

  useEffect(() => {
    async function fetchProblem() {
      try {
        const response = await api.getComplaint(ProblemId);
        const data = await response.json();

        setText(data.text || "");
        setTitle(data.title || "");
        setOrganization(data.organization || "");
        setUser(data.user || "");
        setPublished(Boolean(data.published));
        setStatus(Boolean(data.status));
      } catch (error) {
        alert("Could not fetch complaint data: " + error);
      } finally {
        setLoading(false);
      }
    }

    fetchProblem();
  }, [ProblemId]);

  const handleSave = async () => {
    try {
      if (!text || !title || !ProblemId) {
        setToastMessage("All fields must be filled!");
        setShowToast(true);
        return;
      }

      const body = { Id: ProblemId, title, text, published };
      const response = await api.updateComplaint(body);

      if (response.status === 200) {
        setToastMessage("Complaint updated successfully!");
      } else if (response.status === 400) {
        const data = await response.text();
        const message = JSON.parse(data);
        setToastMessage(message);
      } else {
        setToastMessage("An error occurred. Please try again.");
      }
    } catch (error) {
      alert("An error occurred while saving: " + error);
    }

    setShowToast(true);
  };

  return (
    <div className="container py-4">
      <h2 className="edit-title">Editează Problema</h2>

      <div ref={editorRef} className="editor"></div>

      <div className="form-group">
        <label className="form-label">Titlu</label>
        <input
          type="title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          className="form-input"
        />
      </div>

      <div className="form-group">
        <label className="form-label">Organizaţie</label>
        <input
          type="text"
          value={organization}
          readOnly
          className="form-input"
        />
      </div>

      <div className="form-group">
        <label className="form-label">Utilizator</label>
        <input
          type="text"
          value={user}
          readOnly
          className="form-input"
        />
      </div>

      <div className="form-group">
        <label className="form-label">Publicată</label>
        <select
          value={published ? "true" : "false"}
          onChange={(e) => setPublished(e.target.value === "true")}
          className="form-input"
        >
          <option value="true">Yes</option>
          <option value="false">No</option>
        </select>
      </div>

      <div className="form-group">
        <label className="form-label">Status</label>
        <select
          value={status ? "true" : "false"}
          onChange={(e) => setStatus(e.target.value === "true")}
          className="form-input"
        >
          <option value="false">Initiat</option>
          <option value="true">Rezolvat</option>
        </select>
      </div>

      <div className="buttons-container">
        <button onClick={handleSave} className="btn-save">
          Salvare
        </button>

        <Link to={"/dashboard"} className="link-button">
          <button className="btn-cancel">
            Anulare
          </button>
        </Link>
      </div>

      <div className="toast-container">
        <Toast
          onClose={() => setShowToast(false)}
          show={showToast}
          delay={5000}
          autohide
          className="toast-custom"
          animation={false}
        >
          <Toast.Header>
            <span className="toast-title">Notificare</span>
          </Toast.Header>
          <Toast.Body className="toast-message">{toastMessage}</Toast.Body>
        </Toast>
      </div>
    </div>
  );
}

export default ProblemEditPage;
